export default "__VITE_ASSET__4d45d3f4__"